import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createStationOilGunInfo, deleteStationOilGunInfo as _deleteStationOilGunInfo, deleteStationOilGunInfoByIds, updateStationOilGunInfo, findStationOilGunInfo, getStationOilGunInfoList } from '@/api/bairun/stationOilGunInfo'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo';
import { getStationOilEngineInfoList } from '@/api/bairun/stationOilEngineInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'StationOilGunInfo',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatOilGunStatusTag: function formatOilGunStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'success' : bool === 2 ? 'danger' : bool === 3 ? 'warning' : 'info';
      } else {
        return 'info';
      }
    },
    formatOilGunStatusText: function formatOilGunStatusText(bool) {
      if (bool != null) {
        return bool === 1 ? '运行中' : bool === 2 ? '已停止' : bool === 3 ? '维护中' : '未知';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getStationOilGunInfoList,
      stationBaseList: [],
      stationOilTankList: [],
      stationOilEngineList: [],
      oilGunStatusDict: [],
      oilCodeDict: [],
      actionType: null,
      dialogFormVisible: false,
      dialogStatusFormVisible: false,
      deleteVisible: false,
      multipleSelection: [],
      tankSelectOilCode: null,
      formData: {
        stationId: null,
        stationOilTankData: {
          tankId: null,
          tankName: null,
          tankNo: null,
          oilCode: null
        },
        stationOilTankId: null,
        oilCode: null,
        stationOilEngineId: null,
        oilGunNo: null,
        oilGunStatus: null,
        oilGunRemark: null
      },
      rules: {
        stationId: [{
          required: true,
          message: '请选择需要配置的油站',
          trigger: 'blur'
        }],
        stationOilTankData: [{
          required: true,
          message: '请选择油罐',
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (!_this.formData.stationOilTankData.tankId || _this.formData.stationOilTankData.tankId <= 0) {
              callback(new Error('请选择油罐'));
            } else {
              callback();
            }
          }
        }],
        stationOilEngineId: [{
          required: true,
          message: '请选择油机',
          trigger: 'blur'
        }],
        oilGunNo: [{
          required: true,
          message: '请输入油枪号',
          trigger: 'blur'
        }],
        oilGunStatus: [{
          required: true,
          message: '请输入油枪状态',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getTableData();

              case 2:
                _context3.next = 4;
                return _this3.setStartMap();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;

      if (this.searchInfo.oilEngineStatus === '') {
        this.searchInfo.oilEngineStatus = null;
      }

      this.getTableData();
    },
    updateStationOilGunInfo: function updateStationOilGunInfo(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, stationOilTankData, i, stationOilEngineData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return findStationOilGunInfo({
                  ID: row.ID
                });

              case 2:
                res = _context4.sent;
                _this4.actionType = 'update';

                if (!(res.code === 0)) {
                  _context4.next = 34;
                  break;
                }

                _this4.formData = res.data.resStationOilGunInfo;
                _this4.dialogFormVisible = true;

                if (!row.stationId) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 10;
                return getStationOilTankInfoList({
                  stationId: row.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 10:
                _context4.t0 = _context4.sent;
                _context4.next = 14;
                break;

              case 13:
                _context4.t0 = {
                  data: []
                };

              case 14:
                stationOilTankData = _context4.t0;
                _this4.stationOilTankList = stationOilTankData.data.list;
                _context4.t1 = regeneratorRuntime.keys(_this4.stationOilTankList);

              case 17:
                if ((_context4.t2 = _context4.t1()).done) {
                  _context4.next = 24;
                  break;
                }

                i = _context4.t2.value;

                if (!(_this4.stationOilTankList[i].ID === _this4.formData.stationOilTankId)) {
                  _context4.next = 22;
                  break;
                }

                _this4.formData.stationOilTankData = {
                  tankId: _this4.stationOilTankList[i].ID,
                  tankName: _this4.stationOilTankList[i].oilTankName,
                  tankNo: _this4.stationOilTankList[i].oilTankNo,
                  oilCode: _this4.stationOilTankList[i].oilCode
                };
                return _context4.abrupt("break", 24);

              case 22:
                _context4.next = 17;
                break;

              case 24:
                console.log(_this4.formData);

                if (!row.stationId) {
                  _context4.next = 31;
                  break;
                }

                _context4.next = 28;
                return getStationOilEngineInfoList({
                  stationId: row.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 28:
                _context4.t3 = _context4.sent;
                _context4.next = 32;
                break;

              case 31:
                _context4.t3 = {
                  data: []
                };

              case 32:
                stationOilEngineData = _context4.t3;
                _this4.stationOilEngineList = stationOilEngineData.data.list;

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        stationId: null,
        stationOilTankData: {
          tankId: null,
          tankName: null,
          tankNo: null,
          oilCode: null
        },
        stationOilTankId: null,
        oilCode: null,
        stationOilEngineId: null,
        oilGunNo: null,
        oilGunStatus: null,
        oilGunRemark: null
      };
    },
    deleteStationOilGunInfo: function deleteStationOilGunInfo(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                row.visible = false;
                _context5.next = 3;
                return _deleteStationOilGunInfo({
                  ID: row.ID
                });

              case 3:
                res = _context5.sent;

                if (!(res.code === 0)) {
                  _context5.next = 9;
                  break;
                }

                _this5.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this5.tableData.length === 1 && _this5.page > 1) {
                  _this5.page--;
                }

                _context5.next = 9;
                return _this5.getTableData();

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBatchDeleteStationOilGunInfo: function onBatchDeleteStationOilGunInfo() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ids = [];
                _this6.multipleSelection && _this6.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context6.next = 4;
                return deleteStationOilGunInfoByIds({
                  ids: ids
                });

              case 4:
                res = _context6.sent;

                if (!(res.code === 0)) {
                  _context6.next = 11;
                  break;
                }

                _this6.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this6.tableData.length === ids.length) {
                  _this6.page--;
                }

                _this6.deleteVisible = false;
                _context6.next = 11;
                return _this6.getTableData();

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('enterDialog:', _this7.formData);
                _context8.next = 3;
                return _this7.$refs['elForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (valid) {
                              _context7.next = 2;
                              break;
                            }

                            return _context7.abrupt("return");

                          case 2:
                            _context7.t0 = _this7.actionType;
                            _context7.next = _context7.t0 === 'create' ? 5 : _context7.t0 === 'update' ? 9 : 13;
                            break;

                          case 5:
                            _context7.next = 7;
                            return createStationOilGunInfo(_this7.formData);

                          case 7:
                            res = _context7.sent;
                            return _context7.abrupt("break", 15);

                          case 9:
                            _context7.next = 11;
                            return updateStationOilGunInfo(_this7.formData);

                          case 11:
                            res = _context7.sent;
                            return _context7.abrupt("break", 15);

                          case 13:
                            _this7.$message({
                              type: 'info',
                              message: '无效操作'
                            });

                            return _context7.abrupt("return");

                          case 15:
                            if (!(res.code === 0)) {
                              _context7.next = 20;
                              break;
                            }

                            _this7.$message({
                              type: 'success',
                              message: '操作成功'
                            });

                            _this7.closeDialog();

                            _context7.next = 20;
                            return _this7.getTableData();

                          case 20:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 唤起弹窗 新增油枪基础信息
    openAddStationOilGunInfoDialog: function openAddStationOilGunInfoDialog() {
      this.actionType = 'create';
      this.dialogFormVisible = true;
    },
    stationSelectChange: function stationSelectChange(station) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var stationOilTankData, stationOilEngineData;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!station) {
                  _context9.next = 6;
                  break;
                }

                _context9.next = 3;
                return getStationOilTankInfoList({
                  stationId: station,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 3:
                _context9.t0 = _context9.sent;
                _context9.next = 7;
                break;

              case 6:
                _context9.t0 = {
                  data: []
                };

              case 7:
                stationOilTankData = _context9.t0;
                _this8.stationOilTankList = stationOilTankData.data.list;

                if (!station) {
                  _context9.next = 15;
                  break;
                }

                _context9.next = 12;
                return getStationOilEngineInfoList({
                  stationId: station,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 12:
                _context9.t1 = _context9.sent;
                _context9.next = 16;
                break;

              case 15:
                _context9.t1 = {
                  data: []
                };

              case 16:
                stationOilEngineData = _context9.t1;
                _this8.stationOilEngineList = stationOilEngineData.data.list;
                _this8.formData.stationId = station;
                _this8.searchInfo.stationId = station;

              case 20:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    tankSelectChange: function tankSelectChange(item) {
      this.formData.stationOilTankData.tankId = item.tankId;
      this.formData.stationOilTankData.oilCode = item.oilCode;
      this.formData.stationOilTankData.tankName = item.tankName;
      this.formData.stationOilTankData.tankNo = item.tankNo;
      this.formData.stationOilTankId = item.tankId;
      this.formData.oilCode = item.oilCode;
      console.log(this.formData);
    },
    setStartMap: function setStartMap() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var stationBaseData, stationOilTankData, stationOilEngineData;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return getDict('oilGunStatus');

              case 2:
                _this9.oilGunStatusDict = _context10.sent;
                _context10.next = 5;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 5:
                stationBaseData = _context10.sent;
                _this9.stationBaseList = stationBaseData.data.list;

                if (!_this9.searchInfo.stationId) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 10;
                return getStationOilTankInfoList({
                  stationId: _this9.searchInfo.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 10:
                _context10.t0 = _context10.sent;
                _context10.next = 14;
                break;

              case 13:
                _context10.t0 = {
                  data: []
                };

              case 14:
                stationOilTankData = _context10.t0;
                _this9.stationOilTankList = stationOilTankData.data.list;

                if (!_this9.searchInfo.stationId) {
                  _context10.next = 22;
                  break;
                }

                _context10.next = 19;
                return getStationOilEngineInfoList({
                  stationId: _this9.searchInfo.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 19:
                _context10.t1 = _context10.sent;
                _context10.next = 23;
                break;

              case 22:
                _context10.t1 = {
                  data: []
                };

              case 23:
                stationOilEngineData = _context10.t1;
                _this9.stationOilEngineList = stationOilEngineData.data.list;
                _context10.next = 27;
                return getDict('oilCode');

              case 27:
                _this9.oilCodeDict = _context10.sent;

              case 28:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  }
};